import React, {useCallback, useEffect, useState} from 'react';
import TextField from "@material-ui/core/TextField";
import {
    Button,
    FormControlLabel,
    Grid,
    InputBase,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    useMediaQuery
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "react-redux";
import {addPatient, setListOfPatients} from "@cabinet-packages/redux";
import {useHistory} from "react-router";
import {getCheckForAuthorized, setRegisterChild} from "@cabinet-packages/api";
import moment from 'moment';
import 'moment/locale/uk';
import Typography from "@material-ui/core/Typography";
import MuiPhoneNumber from "material-ui-phone-number";
import AdmitIcon from "@material-ui/icons/CheckCircle";
import {getDateInputPattern} from "../utils/InputValuePatterns";

export const roleOptions = [
    {
        value: 'mother',
        label: "Мати"
    },
    {
        value: 'father',
        label: "Тато"
    },
    {
        value: 'soon',
        label: "Син"
    },
    {
        value: 'daughter',
        label: "Донька"
    },
    {
        value: 'grandfather',
        label: "Дідусь"
    },
    {
        value: 'grandmother',
        label: "Бабуся"
    },
    {
        value: 'null',
        label: 'Не визначено'
    }
]

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        minHeight: 'max-content',
        padding: '16px'
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',

        '@media (max-width: 1040px)': {
            padding: '5px',
            width: '100%',
        },
    },
    birthdayContainer: {
        padding: '4px 0',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto 1fr',
        gridGap: '5px',
    },
    formAnnotation: {
        fontSize: '11px',
        color: theme.palette.secondary.light,
    },
    actionButtonContainer: {
        padding: '5px 0',

        '@media (max-width: 1040px)': {
            padding: '5px',
        },
    },
    actionButton: {
        width: '100%',
    },
    addNewPatientMessage: {
        textAlign: 'center',
        fontSize: '18px',
    },
    inputRoot: {
        padding: '5px 5px 5px 10px',
        border: `1px solid #e8e8e8`,
        borderRadius: '5px',
        height: '40px'
    },
    inputLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '12px',
        margin: '10px'
    },
    actionContainer: {
        padding: '20px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        columnGap: '20px',
        marginTop: '20px',
        height: '50px'
    },
    cancelEditButton: {
        fontSize:'1rem',
        color: theme.palette.colors.text,
    },
    headerLabel: {
        color: theme.palette.primary.dark
    },
    extraLabel: {
        color: theme.palette.primary.main
    },
    selectContainer: {
        fontSize: '15px',
        height: '60px',
        color: 'black',
        fontWeight: '500 !important',
        '&.Mui-disabled': {
            fontSize: '15px',
            color: 'white',
            backgroundColor: '#00B3A1',
            position: 'relative'
        },
    },
    radioContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    },
    radioCheckedLabel: {
        fontSize: '15px'
    },
    radioUncheckedLabel: {
        fontSize: '15px',
        color: theme.palette.grey.text
    }
}))

moment.locale('uk');

const CabinetAddNewPatient = ({isInDialog}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))
    const {listOfPatients} = useSelector(state => state.patients);
    const todayDate = new Date();
    const initialPatient = {
        firstname: '',
        lastname: '',
        fathername: '',
        dt: todayDate,
        sex: 'F',
        phone: '',
        email: '',
        role: 'null',
        customRole: '',
        regDate: todayDate,
    };
    const [valueActivePatient, setValueActivePatient] = useState(initialPatient);
    const [isUserSendData, setIsUserSendData] = useState(false);
    const [error, setError] = useState(false);

    const handleClickOnAction = async (event) => {
        event.stopPropagation();
        event.preventDefault();

        const mainPatientId = listOfPatients.find(patient => patient.main).id;
        const birthdayDate = moment(valueActivePatient.birthday, 'DD / MM / YYYY').format('YYYY-MM-DD')

        setIsUserSendData(true);

        const patient = await setRegisterChild(
            mainPatientId,
            valueActivePatient.lastname,
            valueActivePatient.firstname,
            valueActivePatient.fathername,
            birthdayDate,
            valueActivePatient.sex,
            valueActivePatient.email,
            valueActivePatient.role === 'null' ? valueActivePatient.customRole : valueActivePatient.role
        ).catch(error => setError(true))
        await getCheckForAuthorized();

        dispatch(addPatient(patient));
    };

    const updateStateActivePatient = useCallback((field, value) => {
        // console.log(field + " : " + value)

        setValueActivePatient(prev => ({
            ...prev,
            [field]: value,
        }));
    },[dispatch]);

    useEffect(() => {
        if (!listOfPatients) dispatch(setListOfPatients());
    }, [dispatch, listOfPatients]);

    return (<div className={classes.root}>
        {valueActivePatient &&
            <div className={classes.bodyContainer}>
                {isUserSendData
                    ? <>
                        {isInDialog
                            ? <Typography className={classes.addNewPatientMessage}>{error ? 'Вибачте, виникла помилка.' : 'Нового пацієнта додано.'}</Typography>
                            : <Typography className={classes.addNewPatientMessage}>
                                Нового пацієнта додано, він зявиться у вашому кабінеті.
                            </Typography>}
                        <div className={classes.actionButtonContainer}>
                            {!isInDialog && <Button
                                className={classes.actionButton}
                                variant="outlined"
                                color="primary"
                                onClick={() => history.push('/account-settings')}
                            >
                                Перейти до списку пацієнтів
                            </Button>}
                        </div>
                    </>
                    :
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{marginBottom: '10px'}}>
                            <Typography color={"textPrimary"} variant={'h4'} className={classes.headerLabel}>
                                Новий пацієнт
                            </Typography>
                            <Typography className={classes.extraLabel}>
                                Додайте пацієнта у ваш ообистий кабінет
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel className={classes.inputLabel}>Прізвище</InputLabel>
                            <InputBase
                                variant="standard"
                                value={valueActivePatient.lastname}
                                onChange={(event) => updateStateActivePatient('lastname', event.target.value)}
                                fullWidth
                                className={classes.inputRoot}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel className={classes.inputLabel}>Ім'я</InputLabel>
                            <InputBase
                                variant="standard"
                                value={valueActivePatient.firstname}
                                onChange={(event) => updateStateActivePatient('firstname', event.target.value)}
                                fullWidth
                                className={classes.inputRoot}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel className={classes.inputLabel}>По-батькові</InputLabel>
                            <InputBase
                                variant="standard"
                                value={valueActivePatient.fathername}
                                onChange={(event) => updateStateActivePatient('fathername', event.target.value)}
                                fullWidth
                                className={classes.inputRoot}
                            />
                        </Grid>
                        <Grid item xs={mdUp ? 6 : 12}>
                            <InputLabel className={classes.inputLabel}>Контактний телефон</InputLabel>
                            <MuiPhoneNumber
                                defaultCountry='ua'
                                countryCodeEditable={false}
                                fullWidth={true}
                                onChange={(phone) => {
                                    updateStateActivePatient('phone', phone)
                                }}
                                disableDropdown={true}
                                InputProps={{
                                    disableUnderline: true,
                                    style: {height: '40px'}
                            }}
                                className={classes.inputRoot}
                            />
                        </Grid>
                        <Grid item xs={mdUp ? 4 : 6}>
                            <InputLabel className={classes.inputLabel}>Дата народження</InputLabel>
                            <InputBase
                                variant="standard"
                                value={getDateInputPattern(valueActivePatient.birthday ? valueActivePatient.birthday : '')}
                                onChange={(event) => updateStateActivePatient('birthday', event.target.value)}
                                className={classes.inputRoot}
                            />
                        </Grid>
                        <Grid item xs={mdUp ? 2 : 6}>
                            <InputLabel className={classes.inputLabel}>Стать</InputLabel>
                            <RadioGroup
                                className={classes.radioContainer}
                                value={valueActivePatient.sex}
                                onChange={(event) => {updateStateActivePatient('sex', event.target.value)}}>
                                    <FormControlLabel classes={{label: valueActivePatient.sex === 'F' ? classes.radioCheckedLabel : classes.radioUncheckedLabel}}
                                                      value="F"
                                                      control={<Radio size={"small"} checkedIcon={<AdmitIcon style={{color: 'green', fontSize: '20px'}}/>}/>}
                                                      label="Ж"
                                                      labelPlacement="start"/>
                                    <FormControlLabel classes={{label: valueActivePatient.sex === 'M' ? classes.radioCheckedLabel : classes.radioUncheckedLabel}}
                                                      value="M"
                                                      control={<Radio size={"small"} checkedIcon={<AdmitIcon style={{color: 'green', fontSize: '20px'}}/>}/>} l
                                                      label="Ч"
                                                      labelPlacement="start"/>
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel className={classes.inputLabel}>Електронна пошта</InputLabel>
                            <InputBase
                                variant="standard"
                                value={valueActivePatient.email}
                                onChange={(event) => updateStateActivePatient('email', event.target.value)}
                                fullWidth
                                className={classes.inputRoot}
                            />
                        </Grid>
                        {/*<Grid item xs={mdUp ? 6 : 12}>*/}
                        {/*    <InputLabel className={classes.inputLabel}>Оберіть роль пацієнта</InputLabel>*/}
                        {/*    <TextField*/}
                        {/*        variant="standard"*/}
                        {/*        value={valueActivePatient.role}*/}
                        {/*        onChange={(event) => {*/}
                        {/*            updateStateActivePatient('customRole', '')*/}
                        {/*            updateStateActivePatient('role', event.target.value)*/}
                        {/*        }}*/}
                        {/*        fullWidth*/}
                        {/*        className={classes.inputRoot}*/}
                        {/*        InputProps={{ disableUnderline: true }}*/}
                        {/*        select*/}
                        {/*    >*/}
                        {/*        <MenuItem classes={{root: classes.selectContainer}} disabled>*/}
                        {/*            РОЛЬ ПАЦІЄНТА*/}
                        {/*            /!*<CancelIcon style={{position: 'absolute', right: 10, fontSize: '20px'}}/>*!/*/}
                        {/*        </MenuItem>*/}
                        {/*        {roleOptions.map((item) => (*/}
                        {/*            <MenuItem classes={{root: classes.selectContainer}} value={item.value}>{item.label}</MenuItem>*/}
                        {/*        ))}*/}
                        {/*    </TextField>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={mdUp ? 6 : 12}>*/}
                        {/*    <InputLabel className={classes.inputLabel}>Або введіть роль вручну</InputLabel>*/}
                        {/*    <InputBase*/}
                        {/*        variant="standard"*/}
                        {/*        placeholder={"Напишіть ким для Вас є цей пацієнт"}*/}
                        {/*        value={valueActivePatient.customRole}*/}
                        {/*        onChange={(event) => {*/}
                        {/*            updateStateActivePatient('role', 'null')*/}
                        {/*            updateStateActivePatient('customRole', event.target.value)*/}
                        {/*        }}*/}
                        {/*        fullWidth*/}
                        {/*        className={classes.inputRoot}*/}
                        {/*        InputProps={{*/}
                        {/*            classes: { input: classes.inputRoot}*/}
                        {/*        }}*/}
                        {/*    />*/}
                        {/*</Grid>*/}
                        <Grid item xs={12} className={classes.actionContainer}>
                            <Button className={classes.cancelEditButton}>
                                СКАСУВАТИ
                            </Button>
                            <Button className={classes.cancelEditButton}
                                    variant="outlined"
                                onClick={(event) => handleClickOnAction(event)}
                                disabled={
                                    valueActivePatient.firstname.length === 0
                                    || valueActivePatient.lastname.length === 0
                                    || valueActivePatient.email.length === 0
                                    || !valueActivePatient.email.includes('@')
                                    || !valueActivePatient.email.includes('.')
                                    || valueActivePatient.fathername.length === 0
                                    // || (valueActivePatient.customRole === '' && valueActivePatient.role === 'null')
                                }
                            >
                                ЗБЕРЕГТИ
                            </Button>
                        </Grid>
                    </Grid>
                }
            </div>
        }
    </div>);
};

export default CabinetAddNewPatient;
